import * as React from "react";
import {connect} from "react-redux";
import {RootState} from "../../store/reducer/root/RootState";
import Account from "../../model/account/Account";
import {Option} from "ts-option";
import {getAccount} from "../../store/view/account";

interface ComponentProps {
	partnerBrandId: string,
	accountCode: string
}

interface ReduxProps {
	account: Option<Account>;
}

type Props = ComponentProps & ReduxProps;

/**
 * Account name presenter.
 */
class AccountNamePresenter extends React.PureComponent <Props, {}> {
	render() {
		return this.props.account.map(a => a.name).orNull;
	}
}

function mapStateToProps(state: RootState, props: Props) {
	return {account: getAccount(props.partnerBrandId, props.accountCode, state)}
}

export default connect<ReduxProps, null, ComponentProps>(mapStateToProps, null)(AccountNamePresenter)
